import * as constantes from '../../constantes';
import React, { Component } from 'react';
import { Button , Container , Checkbox , Confirm , Dimmer , Grid ,  Header ,Icon , Label, Loader, Modal , Popup , Segment , Table } from 'semantic-ui-react'; 
import { Dropdown , Form , Input } from 'semantic-ui-react-form-validator';
import { useParams , Link } from 'react-router-dom';

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;

const style = {
    h1: {
      marginTop: '1em',
    },
    h2: {
      margin: '1em 0em 1em',
    },
    h3: {
      marginTop: '2em',
      padding: '2em 0em',
    },
    last: {
      marginBottom: '300px',
    },
}

const tipoControl = [
    { key: '1', value: 1 , text: 'radio' },
    { key: '2', value: 2 , text: 'check' },
    { key: '3', value: 3 , text: 'date' },
    { key: '4', value: 4 , text: 'text' },
    { key: '5', value: 5 , text: 'textArea' },
    { key: '6', value: 6 , text: 'Select' },
    { key: '7', value: 7 , text: 'text-numeric' },
    { key: '8', value: 8 , text: 'option' },
    { key: '9', value: 9 , text: 'check-doble' },
    { key: '10', value: 10 , text: 'check-doble-titulo' },
    { key: '11', value: 11 , text: 'RadioButtom-toggle' }
]

const tipoRechazoInmediato = [
    { key: '20', value: null , text: '-SELECCIONAR-' },
    { key: '1', value: 0 , text: '0 - CONTINUAR' },
    { key: '2', value: 1 , text: '1 - RECHAZO' },
    { key: '3', value: 2 , text: '2 - NULIDAD (no usado)' },
    { key: '4', value: 3 , text: '3 - Preguntar por Vasquez Romero (HE TERMINADO ADMISIBILIDAD)' },
    { key: '5', value: 4 , text: '4 - HE TERMINADO PROCEDENCIA...PREGUNTAR POR VASQUEZ ROMERO' },
    { key: '6', value: 5 , text: '5 - HE TERMINADO VASQUEZ ROMERO, preguntar por PROCEDENCIA' },
    { key: '7', value: 6 , text: '6 - HE TERMINADO UNA DE JURISPRUDENCIA - TOCA COMPLETAR CHECKLIST DE ADMISIBILIDAD' },
    { key: '8', value: 7 , text: '7 - FUNDADA' },
    { key: '9', value: 8 , text: '8 - INFUNDADA' }
]

const emptyAlternativa = {
    alternativaId : null,
    alternativaPadreId : null,
    preguntaId : null,
    posicion : 1,
    tipoControl : '' ,
    tipoControlId : '' ,
    accion : null,

    checked : 'false',
    checked2 : 'false',
    disabled : 'true',
    
    flujoSegunPregunta : null,
    rechazoInmediato : null,
    resolucionRacId : null,
    saltarAPregunta : null,
    saltarMas : null,
    saltarPosterior : null,
    value : '',
    label : '',
    name : '', 
    estado : 1 ,
    usuarioCreacion : null,
    usuarioModificacion : null,
    fechaCreacion : null,
    fechaModificacion : null,

    showSelectec: true,
    showSelectecSecondCheck: false,
    posicionDisabled : false ,
    verRechazoInmediato : true 
}

const WrappedAlternativas = props => {
   
    const params = useParams()

    return <Alternativas id={params.id} />
}

class Alternativas extends Component{

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            error: null,
            errors: [],
            mensaje : '',
            error2 : '' ,

            preguntaId : props.id,
            pregunta : null,
            listaAlternativas: [], 
            showModalAlternativa:false, 
            activePage:1,
            totalPages:10 ,

            tempAlternativa : emptyAlternativa,
            tempListaPreguntas : null, 
            tempListaAlternativas : null, 

            confirmEliminarAlternativaOpen: false , 
            alternativaIdDelete : null ,
            dimmerEliminarAlternativa :  false ,

        };

        this._onChangeSelectTipoControl = this._onChangeSelectTipoControl.bind(this);
        this._onChangeSelectRechazo = this._onChangeSelectRechazo.bind(this);
        this._onChangeSelectAltPradre = this._onChangeSelectAltPradre.bind(this);
        
        this._onCheckAlternativaObj = this._onCheckAlternativaObj.bind(this); 

        this.editarAlternativa = this.editarAlternativa.bind(this);
        this.nuevaAlternativa = this.nuevaAlternativa.bind(this);
        this.registrarAlternativa = this.registrarAlternativa.bind(this);
        this.eliminarAlternativa = this.eliminarAlternativa.bind(this);
        
        this.setShowModal =this.setShowModal.bind(this) ;
        this._handlerChangeTextAlternativaObject = this._handlerChangeTextAlternativaObject.bind(this);
        //this._handlerChangeTextAlternativaPadreObject = this._handlerChangeTextAlternativaPadreObject.bind(this);
        
    }

    componentDidMount() {
        let METHODNAME = 'componentDidMount - ';
        console.log(METHODNAME + 'INI');

        auth0Client.isExpired();

        this.cargarListaDeAlternativas( this.state.preguntaId );

        console.log(METHODNAME + 'FIN');
    }

    async nuevaAlternativa(){
        let METHODNAME = 'nuevaAlternativa - ';
        console.log(METHODNAME + 'INI.' );

        this.setState({
            showModalAlternativa : true,
            tempAlternativa : emptyAlternativa 
        });

        this.cargarTempListaPreguntas();
        /*
        const jsonSelects = await this.cargarTempListaPreguntas();
        jsonSelects.then( () => {
            console.log( METHODNAME + 'Aqui ya termino de cargar la lista temp de preguntas ' );
        });*/
        //aqui luego de cargar la lista temp , 

    }
    
    editarAlternativa( idAlternativa ){
        let METHODNAME = 'editarAlternativa - ';
        console.log(METHODNAME + 'INI. idAlternativa = ' + idAlternativa );

        this.setState({
            showModalAlternativa : false ,
            tempAlternativa : emptyAlternativa, 
            error2 : '' ,
        });

        this.cargarTempListaPreguntas();

        //let _showSelectec = true;
        //let _showSelectecSecondCheck = false;
        let _posicionDisabled = false;

        let url = server+`/alternativas/${idAlternativa}` ;
        
        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } 
        })
        .then(res => res.json())
        .then(
            
            (result) => {

                if( result.resultado === 'true' ){

                    if( result.alternativa.tipoControl ){ }

                    if( result.alternativa.alternativaPadreId && result.alternativa.alternativaPadreId.toString().length > 0 ){
                        _posicionDisabled = true; 
                    }

                    let _verRechazoInmediato = true;
                    const tipoCtrl = result.alternativa.tipoControl ? result.alternativa.tipoControl.tipoControlId : null ;
                    switch( tipoCtrl ){ 
                        case 6 : //Select 
                            _verRechazoInmediato = false;
                            break; 
                        case 8 : //option
                            _verRechazoInmediato = false;
                            break; 
                        default : 
                            //11 - radio_toggle
                    }

                    this.setState({
                        isLoaded: true,
                        showModalAlternativa : true ,
                        tempAlternativa : {
                            alternativaId : result.alternativa.alternativaId,
                            alternativaPadreId : result.alternativa.alternativaPadreId,
                            resolucionRacId : result.alternativa.resolucionRacId,
                            posicion : result.alternativa.posicion,
                            preguntaId : result.alternativa.pregunta ? result.alternativa.pregunta.idPregunta : null ,
                            tipoControlId : result.alternativa.tipoControl ? result.alternativa.tipoControl.tipoControlId : null ,
                            accion : result.alternativa.accion,
                            
                            checked : result.alternativa.checked+'',
                            checked2 : result.alternativa.checked2+'',
                            disabled : !result.alternativa.disabled+'',
                            
                            flujoSegunPregunta : result.alternativa.flujoSegunPregunta,
                            rechazoInmediato : result.alternativa.rechazoInmediato, 
                            verRechazoInmediato : _verRechazoInmediato,
                            saltarAPregunta : result.alternativa.saltarAPregunta,
                            saltarMas : result.alternativa.saltarMas,
                            saltarPosterior : result.alternativa.saltarPosterior,
                            value : result.alternativa.value,
                            label : result.alternativa.label,
                            name : result.alternativa.name,
                            estado : result.alternativa.estado,
                            usuarioCreacion : result.alternativa.usuarioCreacion,
                            usuarioModificacion : result.alternativa.usuarioModificacion,
                            fechaCreacion : result.alternativa.fechaCreacion,
                            fechaModificacion : result.alternativa.fechaModificacion,
                            
                            showSelectec : this.puedeMostrarCampoPreSeleccionado( result.alternativa.tipoControl.tipoControlId ) ,
                            showSelectecSecondCheck : (result.alternativa.tipoControl.tipoControlId === 9),
                            posicionDisabled : _posicionDisabled
                        } 
                    });

                }else{
                    console.error(METHODNAME + 'RESULTADO con error : ' + result.error );
                    this.setState({
                        showModalAlternativa : false ,
                        tempAlternativa : emptyAlternativa,
                        error2 : result.error
                    });
                }
                    
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error2 : error ,
                    error
                });
            }
        )

    }

    registrarAlternativa(){
        let METHODNAME = 'registrarAlternativa - ';
        console.log(METHODNAME + 'INI');

        let url = server+`/alternativas/` ;
        
        let dataForm = {
            authUsername : localStorage.getItem('usuario'), 
            alternativa : { 
                alternativaId : this.state.tempAlternativa.alternativaId,
                alternativaPadreId : this.state.tempAlternativa.alternativaPadreId,
                pregunta : {
                    idPregunta : this.state.preguntaId
                },
                posicion : this.state.tempAlternativa.posicion,
                tipoControl : { 
                    tipoControlId : this.state.tempAlternativa.tipoControlId 
                },
                accion : this.state.tempAlternativa.accion,
                
                checked : (this.state.tempAlternativa.checked==='true'),
                checked2 : (this.state.tempAlternativa.checked2==='true'),
                disabled : !(this.state.tempAlternativa.disabled==='true'),
                
                flujoSegunPregunta : this.state.tempAlternativa.flujoSegunPregunta,
                rechazoInmediato : this.state.tempAlternativa.rechazoInmediato,
                resolucionRacId : this.state.tempAlternativa.resolucionRacId,
                saltarAPregunta : this.state.tempAlternativa.saltarAPregunta,
                saltarMas : this.state.tempAlternativa.saltarMas,
                saltarPosterior : this.state.tempAlternativa.saltarPosterior,
                value : this.state.tempAlternativa.value,
                label : this.state.tempAlternativa.label,
                name : this.state.tempAlternativa.name, 
                estado : this.state.tempAlternativa.estado, 
                usuarioCreacion : this.state.tempAlternativa.usuarioCreacion, 
                usuarioModificacion : this.state.tempAlternativa.usuarioModificacion, 
                fechaCreacion : this.state.tempAlternativa.fechaCreacion, 
                fechaModificacion : this.state.tempAlternativa.fechaModificacion, 
            } 
            
        }

        fetch(
          url , {
          method: 'POST',
          headers:{
              'Accept':'application/json',
              'Content-Type':'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
          } ,
          body:JSON.stringify(dataForm)
        })
        .then(res => res.json())
        .then(
          
          (result) => {

            this.setState({
                isLoaded: true, 
                showModalAlternativa : false,
                tempAlternativa : emptyAlternativa, 
            });

            this.cargarListaDeAlternativas( this.state.preguntaId );
            this.cargarTempListaPreguntas();

          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
              console.log(METHODNAME + 'error = ' + error );
              this.setState({
                  isLoaded: true,
                  error
              });
          }
        )
    
    }

    setShowModal( nombre ,  mostrar ){
        this.setState({
           [nombre]: mostrar
        });
    }

    async cargarListaDeAlternativas( preguntaId ){
        let METHODNAME = 'cargarListaDeAlternativas - ';
        console.log(METHODNAME + 'INI');
 
        let url = server+`/preguntas/${preguntaId}/alternativas`;

        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                console.log(METHODNAME + 'RESULTADO DE LISTA DE ALTERNATIVAS');
                this.setState({
                    isLoaded: true, 
                    pregunta : result.pregunta,
                    listaAlternativas: result.listaAlternativas
                });
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )
        console.log(METHODNAME + 'FIN');
    }
    
    async cargarTempListaPreguntas(){
        let METHODNAME = 'cargarTempListaPreguntas - '; 

        let _tempListaPreguntas = null;
        let _tempListaAlternativas = null;

        let url =  `${server}/preguntas/select/`;
        
        let dataForm = {
            idPregunta : this.state.preguntaId 
        }
            
        const json = await fetch( url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:JSON.stringify(dataForm)
        }).then((result) => {
            
            result.json().then((resp) => {

                if( resp.resultado === 'true' ){
                    
                    _tempListaPreguntas = [];
                    _tempListaAlternativas = [];
                    resp.listaPreguntasSelect.forEach(function(obj) { 
                        _tempListaPreguntas.push( { key: obj.key , text: obj.text , value: parseInt(obj.value) } ); 
                    });

                    let _posicion = 1 ; 
                    _tempListaAlternativas.push( { key: 0 , text: '-Seleccionar-' , value: null } ); 
                    resp.listaAlternativasSelect.forEach(function(obj) { 
                        _tempListaAlternativas.push( { key: obj.key , text: obj.text , value: parseInt(obj.value) } ); 
                        _posicion++ ;
                    });

                    //Solo en caso de NUEVO REGISTRO
                    if( !this.state.tempAlternativa.alternativaId ){
                        this.setState(prevState => ({
                            tempAlternativa:{
                              ...prevState.tempAlternativa,
                              posicion: _posicion
                            }
                        }));
                    }

                    this.setState({ 
                        tempListaPreguntas: _tempListaPreguntas, 
                        tempListaAlternativas : _tempListaAlternativas
                    });

                }else{
                    console.warn(METHODNAME +  'No se pudo obtener la lista. error : ' + resp.error );
                }
                
            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error);
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error);
        });
        
        return json ;
    }

    preEliminarAlternativa( alternativaId ){
        this.setState({
            confirmEliminarAlternativaOpen: true , 
            alternativaIdDelete : alternativaId ,
            dimmerEliminarAlternativa :  false 
        });
    }

    async eliminarAlternativa(){
        let METHODNAME = 'eliminarAlternativa - ';
        console.log( METHODNAME + 'INI ');
   
        if( this.state.alternativaIdDelete === null){
            console.log('No hay ID de alternativa para eliminar');
            return;
        }

        this.setState({ 
            dimmerEliminarAlternativa : true  
        });

        let url =  `${server}/alternativas/${this.state.alternativaIdDelete}/`;
        let dataForm = {
            authUsername : localStorage.getItem('usuario'),
        }
        const json = await fetch( url , {
            method: 'DELETE',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } ,
            body:JSON.stringify(dataForm)
        }).then((result) => {
           
            result.json().then((resp) => {

                if( resp.resultado === 'true' ){
                    console.warn(METHODNAME +  'eliminado correctamente.' );
                    
                    this.setState({
                        confirmEliminarAlternativaOpen: false , 
                        alternativaIdDelete : null ,
                        dimmerEliminarAlternativa :  false  
                    });

                    this.cargarListaDeAlternativas( this.state.preguntaId );

                }else{
                    console.warn(METHODNAME +  'No se pudo eliminar. error : ' + JSON.stringify(resp) );

                    this.setState({ 
                        dimmerEliminarAlternativa : false  
                    });

                }

            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
                this.setState({ 
                    dimmerEliminarAlternativa : false  
                });
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error)
        });

        return json;
    }
    
    _handlerChangeTextAlternativaObject( e ){
        let valor = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            tempAlternativa:{
              ...prevState.tempAlternativa,
              [name]: valor
            }
        }));
    }

    _onChangeSelectAltPradre(e, { name, value }) {
        let METHODNAME = '_onChangeSelectRechazo - ';
        console.log(METHODNAME + 'name = ' + name + '; value = ' + value + '; id = ' + e.target.id );

        let _posicionDisabled = false;
        if( value > 0 ){
            _posicionDisabled = true;
        }else{
            _posicionDisabled = false;
        }

        this.setState(prevState => ({
            tempAlternativa:{
              ...prevState.tempAlternativa,
              [name]: value,
              posicionDisabled : _posicionDisabled 
            }
        }));

    }

    _onChangeSelectRechazo(e, { name, value }) {
        let METHODNAME = '_onChangeSelectRechazo - ';
        console.log(METHODNAME + 'name = ' + name + '; value = ' + value + '; id = ' + e.target.id );

        this.setState(prevState => ({
            tempAlternativa:{
              ...prevState.tempAlternativa,
              [name]: value
            }
        }));

    }

    _onChangeSelectTipoControl(e, { name, value }) {
        //let METHODNAME = '_onChangeSelectTipoControl - ';
        //console.log(METHODNAME + 'name = ' + name + '; value = ' + value + '; id = ' + e.target.id );
        
        let nombre = '';
        let _verRechazoInmediato = true;
        let _rechazoInmediato = null;
        
        switch( value ){
            case 1 : // radio
                nombre = 'valorUnico';
                break;
            case 2 : //check - NO_USADO
                nombre = 'unicoCheck';
                break;
            case 3 : //date
                nombre = 'fechaUno';
                break;
            case 4 : //text - NO_USADO
                nombre = 'inputText';
                break;
            case 5 : //textArea
                nombre = 'info_cant_dias';
                break;
            case 6 : //Select
                nombre = 'select';
                //no permite Rechazo inmediato
                _verRechazoInmediato = false;
                _rechazoInmediato = null;
                break;
            case 7 : //text-numeric
                nombre = 'cant_dias';
                break;
            case 8 : //option 
                nombre = 'option';
                //No permite Rechazo inmediato
                _verRechazoInmediato = false;
                _rechazoInmediato = null;
                break;
            case 9 : //check-doble
                nombre = 'listaChekDoble';
                //_showSelectecSecondCheck = true;
                break;
            case 10 : //check-doble-titulo
                nombre = 'titulo-check';
                break;
            case 11 : //RadioButtom-toggle
                nombre = 'radio_toggle';
                break;
            default : 
                //11 - radio_toggle
        } 

        this.setState(prevState => ({
            tempAlternativa:{
              ...prevState.tempAlternativa,
              [name]: value,
              name : nombre,
              showSelectec : this.puedeMostrarCampoPreSeleccionado( value ),
              showSelectecSecondCheck : ( value === 9 ) ,
              verRechazoInmediato : _verRechazoInmediato,
              rechazoInmediato : _rechazoInmediato,
            }
        }));

    }

     _onCheckAlternativaObj(e, { name, value }) {
        //let METHODNAME = '_onCheckAlternativaObj - '; 

        let isChecked = e.target.checked;
        //console.log(METHODNAME + 'isChecked = ' + isChecked );

        this.setState(prevState => ({
            tempAlternativa:{
              ...prevState.tempAlternativa,
              [name]: isChecked+''
            }
        }));
    }

    handleChangeBoolean( name , mostrar ){
        this.setState({
            [name]: mostrar
        });
    }
    
    puedeMostrarCampoPreSeleccionado( tipoControlId ){
        let resultado = true; 
        if( tipoControlId === 3 || tipoControlId === 4 || tipoControlId === 5 || 
             tipoControlId === 6 || tipoControlId === 7 || tipoControlId === 8 || tipoControlId === 10 ){
            resultado = false;
        }
        return resultado;
    }
    
    render() {

        const { error, isLoaded, pregunta , listaAlternativas } = this.state;

        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {

            return(
            <Container>
            <div>

                <Header as='h2' content='Lista de Alternativas' className='h2' textAlign='center' />
                
                <Segment>
                <Grid columns={2} stackable> 
                    <Grid.Row >
                        <Grid.Column width={3}>
                            Pregunta:
                        </Grid.Column>
                        <Grid.Column width={13}>
                            {pregunta.nombrePregunta}<br/>
                            {pregunta.explicacionPregunta}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                </Segment>

                <div>
                    <Button onClick={ () => this.nuevaAlternativa()}
                            color='green' size='tiny' >
                        <Icon name="save" />        
                        Agregar nueva alternativa</Button>
                </div>

                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Numero</Table.HeaderCell> 
                            <Table.HeaderCell>Posicion</Table.HeaderCell>
                            <Table.HeaderCell>Alt. Padre</Table.HeaderCell>
                            <Table.HeaderCell>Nombre</Table.HeaderCell>
                            <Table.HeaderCell>Label</Table.HeaderCell>
                            <Table.HeaderCell>Value</Table.HeaderCell>
                            <Table.HeaderCell>Tipo Control</Table.HeaderCell>                            
                            <Table.HeaderCell>Acciones</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
            
                    <Table.Body>
                        
                        { listaAlternativas && listaAlternativas.map(alternativa => (
                            <Table.Row key={alternativa.alternativaId}>
                                <Table.Cell> <Label ribbon>{alternativa.alternativaId}</Label> </Table.Cell> 
                                <Table.Cell>{alternativa.posicion}</Table.Cell>
                                <Table.Cell>{alternativa.alternativaPadreId}</Table.Cell>
                                <Table.Cell>{alternativa.name}</Table.Cell>
                                <Table.Cell>{alternativa.label}</Table.Cell>
                                <Table.Cell>{alternativa.value}</Table.Cell>
                                <Table.Cell>{alternativa.tipoControl ? alternativa.tipoControl.nombre : '--'}</Table.Cell>
                                <Table.Cell>

                                    <Button color='blue' animated="vertical" title='Editar alternativa' size='mini'
                                            onClick={ () => this.editarAlternativa(alternativa.alternativaId)} >
                                        <Button.Content visible> <Icon name="edit outline" /></Button.Content>
                                        <Button.Content hidden>
                                            Editar
                                        </Button.Content>
                                    </Button>

                                    <Button color='red' animated="vertical" title='Eliminar alternativa' size='mini'
                                            onClick={ () => this.preEliminarAlternativa(alternativa.alternativaId)}  >
                                        <Button.Content visible>
                                            <Icon name="trash alternate outline" />
                                        </Button.Content>
                                        <Button.Content hidden>
                                            Eliminar
                                        </Button.Content>
                                    </Button>

                                </Table.Cell>
                            </Table.Row>
                        ))}

                    </Table.Body>
            
                </Table>

                <div style={style.divpie}>
                    <Link to={`/baseDeConocimientos` }>
                        <Button primary >
                            <Icon name="reply" />Volver 
                        </Button>
                    </Link> 
                </div>
                 
            </div>

            <Confirm
                open={this.state.confirmEliminarAlternativaOpen}
                header='Eliminar Registro'
                content='¿Está seguro que desea eliminar el registro seleccionado?'
                onCancel={ () => this.handleChangeBoolean('confirmEliminarAlternativaOpen', false )} 
                onConfirm={this.eliminarAlternativa}
            />

            <Dimmer active={this.state.dimmerEliminarAlternativa} inverted >
                <Loader>Loading</Loader>
            </Dimmer>

            <Modal
                as={Form} 
                onSubmit={this.registrarAlternativa} 
                closeIcon
                closeOnEscape={false}
                onClose={() => this.setShowModal( 'showModalAlternativa' , false)} 
                open={this.state.showModalAlternativa}
            >
                <Modal.Header>Información de Alternativa</Modal.Header>

                <Modal.Content>
                    <Modal.Description>
                        <Grid columns={4}>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    Alternativa Padre:
                                    <Popup
                                        trigger={<Icon circular name='question circle' />}
                                        content='Con esto se indica si es que esta alternativa es en realidad una sub alternativa de otra Alternativa principal'
                                        inverted
                                        />
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid 
                                        search
                                        clearable
                                        id='alternativaPadreId'
                                        name='alternativaPadreId'
                                        placeholder='-SELECCIONAR-'
                                        value={this.state.tempAlternativa.alternativaPadreId}
                                        options={this.state.tempListaAlternativas}
                                        onChange={this._onChangeSelectAltPradre}
                                        selection
                                    />
                                </Grid.Column>
                                { !this.state.tempAlternativa.posicionDisabled && 
                                <Grid.Column width={3}>
                                    Posición:
                                    <Popup
                                        trigger={<Icon circular name='question circle' />}
                                        content='Con este valor se puede cambiar el orden que se se mostrará en la pantalla esta alternativa'
                                        inverted
                                        />
                                </Grid.Column>
                                }
                                { !this.state.tempAlternativa.posicionDisabled && 
                                <Grid.Column width={5}>
                                    <Input placeholder='Posición' 
                                        id='posicion' 
                                        name='posicion'
                                        value={this.state.tempAlternativa.posicion} 
                                        onChange = {this._handlerChangeTextAlternativaObject} 
                                        errorMessages={['Se requiere completar este campo']} 
                                        validators={['required']} /> 
                                </Grid.Column>
                                }
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    Texto: 
                                </Grid.Column>
                                <Grid.Column width={13}>
                                    <Input fluid
                                        placeholder='Texto de la alternativa' 
                                        id='label' 
                                        name='label'
                                        value={this.state.tempAlternativa.label} 
                                        onChange = {this._handlerChangeTextAlternativaObject}
                                        errorMessages={['Se requiere completar este campo']} 
                                        validators={['required']} /> 
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    Valor: 
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Input placeholder='Valor'
                                        id='value' 
                                        name='value'
                                        value={this.state.tempAlternativa.value} 
                                        onChange = {this._handlerChangeTextAlternativaObject}
                                        errorMessages={['Se requiere completar este campo']} 
                                        validators={['required']} /> 
                                </Grid.Column>
                                <Grid.Column width={3}>
                                    Tipo de control: 
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        selection
                                        id='tipoControlId'
                                        name='tipoControlId'
                                        placeholder='-SELECCIONAR-'
                                        value={this.state.tempAlternativa.tipoControlId}
                                        options={tipoControl}
                                        onChange={this._onChangeSelectTipoControl} 
                                        errorMessages={['Se requiere completar este campo']} 
                                        validators={['required']} 
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    Habilitado: 
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <div>
                                        <label>NO / SI</label>
                                    </div>
                                    <Checkbox toggle 
                                        type='checkbox'
                                        id='disabled'
                                        name='disabled'
                                        value={this.state.tempAlternativa.disabled}
                                        checked={this.state.tempAlternativa.disabled === 'true'}
                                        onChange={this._onCheckAlternativaObj}
                                    /> 
                                </Grid.Column>
                                { this.state.tempAlternativa.verRechazoInmediato && 
                                <Grid.Column width={3}>
                                    Rechazo Inmediato: 
                                </Grid.Column>
                                }
                                { this.state.tempAlternativa.verRechazoInmediato && 
                                <Grid.Column width={5}> 
                                    <Dropdown
                                        fluid 
                                        id='rechazoInmediato'
                                        name='rechazoInmediato'
                                        placeholder='-SELECCIONAR-'
                                        value={this.state.tempAlternativa.rechazoInmediato}
                                        options={tipoRechazoInmediato}
                                        onChange={this._onChangeSelectRechazo} 
                                        selection
                                    /> 
                                </Grid.Column>
                                }
                            </Grid.Row> 
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    Saltar posiciones:
                                    <Popup
                                        trigger={<Icon circular name='question circle' />}
                                        content='En caso tener claro la cantidad de preguntas que se debe saltar, indicar cuantas posiciones se debe saltar para obtener la siguiente pregunta a mostrar'
                                        inverted
                                        />
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Input id='saltarMas' type='number' placeholder='Saltar posiciones' 
                                        name='saltarMas'
                                        value={this.state.tempAlternativa.saltarMas} 
                                        onChange = {this._handlerChangeTextAlternativaObject}/> 
                                </Grid.Column>
                            </Grid.Row> 
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    Saltar a Pregunta:
                                    <Popup
                                        trigger={<Icon circular name='question circle' />}
                                        content='Seleccionar la pregunta a mostrar en caso seleccione esta alternativa'
                                        inverted
                                        />
                                </Grid.Column>
                                <Grid.Column width={13}>
                                    <Dropdown
                                        fluid 
                                        search
                                        clearable
                                        id='saltarAPregunta'
                                        name='saltarAPregunta'
                                        placeholder='-SELECCIONAR-'
                                        value={this.state.tempAlternativa.saltarAPregunta}
                                        options={this.state.tempListaPreguntas}
                                        onChange={this._onChangeSelectRechazo}
                                        selection
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    Saltar a pregunta segun validacion posterior:
                                    <Popup
                                        trigger={<Icon circular name='question circle' />}
                                        content='Seleccionar pregunta a la cual saltar cuando se utilice una validacion posterior'
                                        inverted
                                        />
                                </Grid.Column>
                                <Grid.Column width={13}>
                                    <Dropdown
                                        fluid 
                                        search
                                        clearable
                                        id='saltarPosterior'
                                        name='saltarPosterior'
                                        placeholder='-SELECCIONAR-'
                                        value={this.state.tempAlternativa.saltarPosterior}
                                        options={this.state.tempListaPreguntas}
                                        onChange={this._onChangeSelectRechazo}
                                        selection
                                    />
                                </Grid.Column> 
                            </Grid.Row>
                        { this.state.tempAlternativa.showSelectec && 
                            <Grid.Row>
                                <Grid.Column width={5}>
                                    Mostrar Pre-Seleccionado:
                                    <Popup
                                        trigger={<Icon circular name='question circle' />}
                                        content='Sirve para que la alternativa ya aparezca pre seleccionada'
                                        inverted
                                        />
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <div>
                                        <label>NO / SI</label>
                                    </div>
                                    <Checkbox toggle 
                                        id='checked'
                                        name='checked'
                                        value={this.state.tempAlternativa.checked}
                                        checked={this.state.tempAlternativa.checked === 'true'}
                                        onChange={this._onCheckAlternativaObj}
                                    /> 
                                </Grid.Column>
                            </Grid.Row>
                        }
                        { this.state.tempAlternativa.showSelectecSecondCheck &&
                            <Grid.Row>
                                <Grid.Column width={5}>
                                    Seleccionado segundo campo:
                                    <Popup
                                        trigger={<Icon circular name='question circle' />}
                                        content='Se habilita cuando el tipo de control es Doble Check'
                                        inverted
                                        />
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <div>
                                        <label>NO / SI</label>
                                    </div>
                                    <Checkbox toggle 
                                        id='checked2'
                                        name='checked2'
                                        value={this.state.tempAlternativa.checked2}
                                        checked={this.state.tempAlternativa.checked2 === 'true'}
                                        onChange={this._onCheckAlternativaObj}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        }
                        </Grid>
                    </Modal.Description>
                </Modal.Content>
          
                <Modal.Actions>
                    <Button color='blue' onClick={() => this.setShowModal( 'showModalAlternativa' ,false)}>
                        Cancelar
                    </Button>
                    <Button
                        content="Regsitrar"
                        labelPosition='right'
                        icon='checkmark'
                        type='submit'
                        color='red'
                    /> 
                </Modal.Actions>

            </Modal>

            </Container>
            
            );

        }
    }
}

export default WrappedAlternativas